// eslint-disable-next-line import/prefer-default-export
export const baseUrl = () => {
  return '/api/';
};
